import React, { createContext, useContext, useMemo, useState } from 'react';
import { periods } from '../data/commissions';
import { BpsAdjustment } from '../types/commission';
interface CommissionDataValue {
  periodId: string;
  setPeriodId: (periodId: string) => void;
  adjustments: Record<string, BpsAdjustment>;
  applyAdjustment: (key: string, value: BpsAdjustment | null) => void;
  overrides: Record<string, BpsAdjustment>;
  saveOverride: (loanId: string, value: BpsAdjustment) => void;
}
const CommissionDataContext = createContext<CommissionDataValue | null>(null);

/** Shared pay period selection and admin edits, so the overview and drill-downs stay in sync. */
export function CommissionDataProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [periodId, setPeriodId] = useState(periods[0].id);
  const [adjustments, setAdjustments] = useState<Record<string, BpsAdjustment>>({});
  const [overrides, setOverrides] = useState<Record<string, BpsAdjustment>>({});
  const value = useMemo<CommissionDataValue>(() => ({
    periodId,
    setPeriodId,
    adjustments,
    applyAdjustment: (key, next) => setAdjustments(current => {
      const copy = {
        ...current
      };
      if (next) copy[key] = next;else delete copy[key];
      return copy;
    }),
    overrides,
    saveOverride: (loanId, next) => setOverrides(current => ({
      ...current,
      [loanId]: next
    }))
  }), [periodId, adjustments, overrides]);
  return <CommissionDataContext.Provider value={value} data-id="element-553" data-mp="3fnoehknyzzpd">{children}</CommissionDataContext.Provider>;
}
export function useCommissionData(): CommissionDataValue {
  const value = useContext(CommissionDataContext);
  if (!value) throw new Error('useCommissionData must be used inside CommissionDataProvider');
  return value;
}